export function LoadingState({ label = 'Loading…' }: { label?: string }) {
  return <p className="feedback feedback--loading" role="status">{label}</p>;
}

export function EmptyState({ message = 'No records found.' }: { message?: string }) {
  return <p className="feedback feedback--empty">{message}</p>;
}

export function ErrorState({ message = 'Unable to load this information.' }: { message?: string }) {
  return <p className="feedback feedback--error" role="alert">{message}</p>;
}
